// Print stuff
import $ from 'jquery';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import * as Site from "../js/site";
import * as Constants from "./constants";

let logoImage;
let mapImageWidth = 708, mapImageHeight = 820;
let MapView, PrintTask, PrintTemplate, PrintParameters, GetSelectedParcelAttributes;
let selectedParcelAttributes;

export const initPrint = (mapView, printTask, printTemplate, printParameters, getSelectedParcelAttributes) => {
  // console.log("Print->initPrint");
  $("#main-print-button").click(function () { createMapImage(); });

  MapView = mapView;
  PrintTask = printTask;
  PrintTemplate = printTemplate;
  PrintParameters = printParameters;
  GetSelectedParcelAttributes = getSelectedParcelAttributes;

  logoImage = new Image();
  logoImage.crossOrigin = "Anonymous";
  logoImage.src = Constants.PrintLogoSrc;
}

export const createMapImage = () => {
  Site.displayMessage("#main-print", "Beginning print process.");

  selectedParcelAttributes = GetSelectedParcelAttributes();

  Site.addToDisplayMessage("#main-print", "Generating map image...", true);

  let factor = 1;
  let printTemplate = new PrintTemplate();
  printTemplate.format = "JPG";
  printTemplate.layout = "MAP_ONLY";
  printTemplate.preserveScale = false;
  printTemplate.exportOptions = {
    width: mapImageWidth * factor,
    height: mapImageHeight * factor,
    dpi: 96 * factor
  };

  let params = new PrintParameters();
  params.view = MapView;
  params.template = printTemplate;

  let printTask = new PrintTask(Constants.printServiceUrl);
  printTask.execute(params)
    .then(function (printResult, printError) {
      let results = printResult;
      let url = printResult.url;
      loadMapImage(printResult.url);
    })
    .catch(function (error) {
      Site.displayError("#main-print", "Print map generation error: " + error.message);
      console.log("Print map generation error: ", error.message);
    });
}

function loadMapImage(url) {
  let title = $.trim($("#main-print-title-input").val());

  Site.addToDisplayMessage("#main-print", "Loading map image...", true);
  let mapImg = new Image();
  mapImg.crossOrigin = "Anonymous";
  mapImg.width = mapImageWidth;
  mapImg.height = mapImageHeight;
  mapImg.onError = function () {
    Site.displayError("#map-print", "Cannot load saved map image: " + url);
  };
  mapImg.onload = function () {
    createPDF(title, mapImg);
  };
  mapImg.src = url;
};

function createPDF(title, mapImage) {
  Site.addToDisplayMessage("#main-print", "Creating PDF...", true);
  let colorWhite = "#FFF";
  let colorTeal = "#007477";
  let colorSand = "#D7C7AF";
  let colorSandDark = "#c6af8d";
  let colorSlate = "#58595B";
  let colorStripe = "#fbf5ed";

  let padding = 3;
  let pageMarginHorizontal = 40;
  let pageMarginVertical = 30;
  let defaultLineWidth = 0.5;
  let pixelFactor = 0.75;

  let doc = new jsPDF("portrait", "pt", "letter");
  doc.setProperties({
    title: "City of Encinitas Print Map",
    subject: title,
    author: "HDR, Inc. (San Diego)",
    keywords: "hdr, gis, encinitas",
    creator: "Land Records Print Utility"
  });

  let pageWidth = (doc.internal.pageSize.width - pageMarginHorizontal * 2);
  doc.setFontSize(13);
  doc.setFont(undefined,"bold");
  doc.setTextColor(colorTeal);

  let rectHeight = 70;
  let footerRectHeight = 45;
  doc.setFillColor(colorSand);
  doc.rect(0, 0, doc.internal.pageSize.width, rectHeight, "F");

  let smRH = 6;
  doc.setFillColor(colorTeal);
  doc.rect(0, rectHeight, doc.internal.pageSize.width, smRH, "F");

  // Title
  let txt = "Land Records Web Map";
  let textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  let textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  //let textOffset = (doc.internal.pageSize.width - textWidth) / 2;
  let textOffset = doc.internal.pageSize.width - pageMarginHorizontal - textWidth;
  let yPos = rectHeight - textHeight * 2.6;
  doc.text(txt, textOffset, yPos);

  txt = title;
  doc.setFontSize(11);
  doc.setTextColor(colorWhite);
  textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  textOffset = doc.internal.pageSize.width - pageMarginHorizontal - textWidth;
  yPos += textHeight * 1.5;
  doc.text(txt, textOffset, yPos);

  // Logo
  let imgHeight = parseInt(logoImage.height * pixelFactor);
  let imgWidth = parseInt(logoImage.width * pixelFactor);
  doc.addImage({
    imageData: logoImage,
    angle: 0,
    x: pageMarginHorizontal,
    y: (rectHeight - imgHeight) / 2,
    w: imgWidth,
    h: imgHeight
  });

  doc.setFontSize(11);
  doc.setFont(undefined, "bold");
  doc.setTextColor(colorSlate);
  yPos = rectHeight + textHeight * 2;

  doc.text("APN: " + selectedParcelAttributes.parcel.APN, pageMarginHorizontal, yPos);
  txt = "Address: " + selectedParcelAttributes.parcel.SitusStreet;
  textWidth = doc.getStringUnitWidth(txt) * doc.internal.getFontSize() / doc.internal.scaleFactor;
  textOffset = doc.internal.pageSize.width - textWidth - pageMarginHorizontal;
  doc.text(txt, textOffset, yPos);

  // Map
  let mapHeight = mapImage.height * pixelFactor;
  let mapWidth = mapImage.width * pixelFactor;
  let mapXPos = doc.internal.pageSize.width - mapWidth - pageMarginHorizontal;
  yPos += textHeight * 0.75;
  doc.addImage({
    imageData: mapImage,
    angle: 0,
    x: mapXPos,
    y: yPos,
    w: mapWidth,
    h: mapHeight
  });

  // Map container borders
  doc.setLineWidth(defaultLineWidth);
  doc.setDrawColor(colorSandDark);
  doc.rect(mapXPos, yPos, mapWidth, mapHeight);

  // Add footer colors
  yPos = doc.internal.pageSize.height - footerRectHeight - smRH;
  doc.setFillColor(colorTeal);
  doc.rect(0, yPos, doc.internal.pageSize.width, smRH, "F");

  yPos += smRH;
  doc.setFillColor(colorSand);
  doc.rect(0, yPos, doc.internal.pageSize.width, footerRectHeight, "F");

  let date = new Date();
  let wId = date.getMinutes() + date.getSeconds();
  let hours = date.getHours();
  let ampm = hours < 12 ? "AM" : "PM";
  if (hours === 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
  }
  let mins = date.getMinutes();
  if (mins < 10) mins = "0" + mins;
  //let reportCreated = `Report created: ${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()} ${date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`;
  let reportCreated = "map created: " + (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + " " + date.getHours() + ":" + mins + " " + ampm;

  doc.setFontSize(10);
  doc.setTextColor(colorWhite);
  textHeight = doc.internal.getFontSize() / doc.internal.scaleFactor;
  yPos += textHeight * 2.5;
  doc.text(reportCreated, pageMarginHorizontal, yPos);

  Site.addToDisplayMessage("#main-print", "PDF creation complete.", true);

  let pdfName = "LandRecordsMap.pdf";
  // Test if browser doesn't support dataUI output (IE)
  if (!Site.iFrameDataUriTest('data:application/pdf;base64,')) {
    Site.addToDisplayMessage("#main-print", "</br>Select report viewing options at the bottom of the browser window.", true);
    doc.save(pdfName);
  } else {
    //doc.output('dataurlnewwindow');
    // Chrome stopped supporting top level data url's. This is the workaround.
    txt = "</br>**Note: If the PDF document did not open in a new browser window or tab, check to see if popups/redirects are being blocked.";
    Site.addToDisplayMessage("#main-print", txt, true);
    let datauri = doc.output("datauristring");
    let urlWithName = datauri.replace("data:application/pdf;", "data:application/pdf;name=" + pdfName + ";");
    let html = '<html>' +
      '<style>html, body {padding: 0;margin: 0;} iframe {width:100%;height:100%;border: 0;}</style>' +
      '<body>' +
      '<iframe type="application/pdf" src="' + urlWithName + '"></iframe>' +
      '</body></html>';
    let w = window.open("about:blank", pdfName + wId);
    w.document.write(html);
    w.document.close();
  }
}

function getAttributeValue(attr) {
  let val = "";
  if (selectedParcelAttributes.zoning) {
    val = selectedParcelAttributes.zoning[attr];
    if (val === "Null") val = "";
  }
  return val;
}